// Class-string tokens for the shared question components.
//
// Two contexts consume these: the kiosk (big touch targets for wall-mounted
// iPads, tightened on phone) and the public inquiry form (compact, desktop-
// form density). Components accept a `size` prop and read from this table so
// a class change only needs to happen here.
//
// Kiosk tokens are mobile-first — narrower padding + text at small screens,
// stepped up at the `sm:` breakpoint to the original kiosk scale. This
// mirrors the responsive tightening already applied to KioskQuestionsForm.
//
// State-dependent classes (e.g. border color on error) stay in the component
// and are layered on top of the token via `:class="[t.input, maybeError]"`.

const kiosk = {
  wrapper: 'space-y-2',
  wrapperLoose: 'space-y-3',
  label: 'block text-lg sm:text-xl font-medium text-gray-700',
  subLabel: 'block text-sm sm:text-base font-medium text-gray-600 mb-1',
  subtext: 'text-sm sm:text-base text-gray-500',
  helperText: 'text-sm text-gray-500',
  input: [
    'w-full px-3 py-3 sm:px-4 sm:py-4',
    'text-base sm:text-xl',
    'border sm:border-2 rounded-lg',
    'focus:outline-none transition',
  ].join(' '),
  optionButton: [
    'w-full py-3 px-4 sm:py-4 sm:px-6',
    'text-base sm:text-xl text-left',
    'rounded-lg border sm:border-2 transition',
    'flex items-center gap-3',
  ].join(' '),
  splitButton: [
    'flex-1 py-3 px-4 sm:py-4 sm:px-6',
    'text-base sm:text-xl font-semibold',
    'rounded-lg border sm:border-2 transition',
  ].join(' '),
  error: 'text-red-500 text-sm sm:text-base font-medium',
  optionIndicator: [
    'w-5 h-5 sm:w-6 sm:h-6',
    'flex-shrink-0 flex items-center justify-center',
  ].join(' '),
  optionIndicatorInner: 'w-2.5 h-2.5 sm:w-3 sm:h-3',
  uploadArea: [
    'flex flex-col items-center justify-center',
    'w-full h-32 sm:h-40',
    'border-2 border-dashed rounded-lg',
    'cursor-pointer transition',
  ].join(' '),
  uploadAreaText: 'text-base sm:text-lg text-gray-600 font-medium',
};

const form = {
  wrapper: 'space-y-1',
  wrapperLoose: 'space-y-2',
  label: 'block text-sm font-medium text-gray-700',
  subLabel: 'block text-sm font-medium text-gray-600 mb-1',
  subtext: 'text-sm text-gray-500',
  helperText: 'text-xs text-gray-500',
  input: [
    'w-full py-3 px-4 text-base',
    'border rounded-md',
    'focus:outline-none transition',
  ].join(' '),
  optionButton: [
    'w-full py-3 px-4 text-base text-left',
    'rounded-md border transition',
    'flex items-center gap-3',
  ].join(' '),
  splitButton: [
    'flex-1 py-3 px-4 text-base font-medium',
    'rounded-md border transition',
  ].join(' '),
  error: 'text-red-600 text-sm',
  optionIndicator: 'w-5 h-5 flex-shrink-0 flex items-center justify-center',
  optionIndicatorInner: 'w-2.5 h-2.5',
  uploadArea: [
    'flex flex-col items-center justify-center',
    'w-full h-32',
    'border-2 border-dashed rounded-md',
    'cursor-pointer transition',
  ].join(' '),
  uploadAreaText: 'text-sm text-gray-600 font-medium',
};

export const QUESTION_SIZE_TOKENS = { kiosk, form };

export function tokensFor(size) {
  return QUESTION_SIZE_TOKENS[size] || QUESTION_SIZE_TOKENS.kiosk;
}
